module.exports = __webpack_public_path__ + "img/checkMethodology.057812bc.svg";